<!--
Use following props     
  "cardHeading" for changing headings,
  "cardContent" for changing card's inner content,
  "profileCompletionPercentage" for changing the percentage of the progress bar,
  "btnText" for changing card's button text
-->

<template>
  <div class="card card-shadows w-100 h-100">
    <p class="source-sans-pro progress-card-heading pl-3">{{cardHeading}}</p>
    <hr class="hr-style m-0 mb-3" />
    <div class="row">
      <div class="col-8 profile-content">
        <p class="text-left source-sans-pro card-content px-3">{{cardContent}}</p>
      </div>
      <div class="col-4">
        <v-progress-circular
          :rotate="-90"
          :size="70"
          :width="5"
          :value="profileCompletionPercentage"
          color="#002d72"
        >
          <p class="source-sans-pro profile-percentage p-0 m-0">{{profileCompletionPercentage}}%</p>
        </v-progress-circular>
      </div>
    </div>
    <div class="w-100">
      <button
        class="setup-btn source-sans-pro font-weight-bold float-left h-100 px-3 pb-2"
        @click="goToModule()"
      >
        {{btnText}}
        <img class="right-arrow" src="@/assets/images/right-arrow.svg" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: [
    "cardHeading",
    "cardContent",
    "profileCompletionPercentage",
    "btnText",
    "linkTo"
  ],
  data() {
    return {};
  },
  computed: {},
  created() {
    // console.log(this.className);
  },
  methods: {
    goToModule() {
      this.$emit("goToModule", this.linkTo);
    }
  }
};
</script>
<style scoped>
.profile-percentage {
  font-size: 21px;
  font-weight: 600;
  line-height: 1.19;
  color: #002d72;
}
.progress-card-heading {
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.25;
  letter-spacing: normal;
  text-align: left;
  color: #636567;
  margin-bottom: 0;
}
.profile-content {
  /* hide text if it more than N lines  */
  content: "...";
  overflow: hidden;
  /* for set '...' in absolute position */
  position: relative;
  /* use this value to count block height */
  line-height: 1.2em;
  /* max-height = line-height (1.2) * lines max number (3) */
  max-height: 3.6em;
  /* fix problem when last visible word doesn't adjoin right side  */
  text-align: justify;
  /* place for '...' */
  margin-right: -1em;
  padding-right: 1em;
}
.setup-btn {
  color: #003a78 !important;
  width: fit-content;
}
.right-arrow {
  width: 25px;
  height: 11px;
  vertical-align: inherit;
}
.card-shadows {
  border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  min-height: 100px !important;
  max-height: 180px !important;
}
.card-content {
  font-size: 16px;
}
</style>